module.exports = __webpack_public_path__ + "static/media/bird.f4bf678a.svg";